<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update_local(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <div v-if="coincidences && coincidences.length" class="alert alert-warning mt-2 p-1" role="alert">
                    <p class="mb-1" v-if="coincidences.length > 1">There are <b>{{ coincidences.length }}</b> other inspection items with a similar name.</p>
                    <p class="mb-1" v-else>There is <b>{{ coincidences.length }}</b> inspection item with a similar name.</p>
                    <span v-for="(item, index) in coincidences" :key="index">
                        <span v-html="item.name"></span>
                        <span v-if="index < coincidences.length - 1"> - </span>
                    </span>
                </div>
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'
import _ from 'lodash'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data() {
        return {
            form_format:    FormResources.form_format,
            room_type_table_headers: Resources.room_type_table_headers,
            coincidences: [],
            room_types: []
        }
    },
    
    methods: {
        debounceInput:  _.debounce(function (e)  {
            if(e)
            {
                this.findCoincidence(e)
            }
            else
            {
                this.coincidences = []
            }
        },600),

        form_submit_update_local(id, index) 
        {
            this.form_submit_update(id, index)
        },
        async findCoincidence(name)
        {
            const res = await this.post(`${this.rest_api}/find_coincidences/results`, {name, id: this.single_object.id})
            if(res.status)
            {
                this.coincidences = res.data.coincidences
            }
            else
            {
                this.coincidences = []
                this.error_handling(res)
            }

        },
    },

    watch: {
        async 'single_object.name' (val)
        {
            this.coincidences = []
            this.debounceInput(val)
        }
    },

    mounted() {
    },

    computed: {
    },
    
}
</script>